import React, { useState } from "react";
import { toast } from "sonner";
import { Shield, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/data/constants";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !pw) return toast.error("Enter email & password");
    setLoading(true);
    try {
      const r = await api.post("/auth/admin-login", { email, password: pw });
      login(r.data.token, r.data.user);
      toast.success("Welcome, Admin");
      window.location.href = "/admin";
    } catch (e) {
      toast.error(e.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-kp-teal-dark flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <img src={LOGO_URL} alt="Krishna Property" className="w-20 h-20 mx-auto rounded-full bg-white p-2"/>
          <h1 className="mt-4 font-display text-white text-2xl font-bold">Krishna Property</h1>
          <p className="text-white/70 text-sm mt-1 flex items-center justify-center gap-1"><Shield size={14}/> Admin Console</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-6 shadow-2xl space-y-4">
          <div>
            <label className="text-xs font-semibold text-slate-600">Admin Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@krishnaproperty.in" data-testid="input-admin-email" autoFocus/>
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600">Password</label>
            <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="••••••••" data-testid="input-admin-password"/>
          </div>
          <Button type="submit" disabled={loading} className="btn-primary w-full rounded-full h-11 font-semibold flex items-center justify-center gap-2" data-testid="btn-admin-login">
            <Lock size={16}/> {loading ? "Signing in..." : "Sign in to Admin"}
          </Button>
          <p className="text-[11px] text-slate-500 text-center">Restricted access. Unauthorized attempts are logged.</p>
        </form>
        <div className="text-center mt-4">
          <a href="/" className="text-xs text-white/70 hover:text-white">← Back to Krishna Property</a>
        </div>
      </div>
    </div>
  );
}
